module.exports = __webpack_public_path__ + "img/hc_pro_three_4.ec5673ab.jpg";